import { Component, EventEmitter, Input, input, Output, ChangeDetectionStrategy } from '@angular/core';
import { SelectModule } from '@openng/optimus-ui/select';
import { IBlockForSelect } from '../../../../utils/blocks-helper';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-add-block',
    imports: [SelectModule, CommonModule],
    templateUrl: './add-block.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './add-block.component.scss'
})
export class AddBlockComponent {
  @Input() blockSelect: IBlockForSelect[] = [];
  @Input() selectedBlocks: any;
  @Input() isNew!: any;
  @Input() lockedBy!: any;
  @Input() currentUser!: any;
  @Input() blockData: any;


  @Output() blockSelectEvent = new EventEmitter<any>();

  /**
   * Emits the selected block value from add block component
   * @param selectedBlock - selected dropdown value
   */
  emitBlockSelect(selectedBlock: any) {
    const spliceIndex = this.selectedBlocks.indexOf(this.blockData) + 1;
    this.blockSelectEvent.emit({ selectedBlock: selectedBlock, spliceIndex: spliceIndex });
  }
}
